import store from '../../store'
import {archiveRecording} from '../../actions/recording'

export function deleteRecording(recordingId) {
	store.dispatch(archiveRecording(recordingId))
}
